import { get, put } from "./fetchWrapper";

const REDEEM_PRODUCT_SNIPPET = (downloadCode) => `/api/include/downloadcode/${downloadCode}`;
const CONFIRM_REDEMPTION_SNIPPET = (downloadCode) => `/api/include/downloadcode/confirmation/${downloadCode}`;
const REDEEM_PRODUCT = (downloadCode) => `/api/downloadcode/${downloadCode}`;
const AUTH_REDIRECT_URL = (downloadCode) => `/shop/home/login/login/?source=${encodeURIComponent(`/downloadcode/?downloadCode=${downloadCode}&ongoing=true`)}`;
const BESTELLEN_SNIPPET = (transactionId) => `/include/bestellen/init?cid=${transactionId}`;

export function getRedeemProductSnippet(downloadCode) {
  return get(
    REDEEM_PRODUCT_SNIPPET(downloadCode),
    "text/html",
    20000,
  );
}

export function getConfirmRedemtionSnippet(downloadCode) {
  return get(
    CONFIRM_REDEMPTION_SNIPPET(downloadCode),
    "text/html",
    20000,
  );
}

export function redeemProduct(downloadCode) {
  return put(
    REDEEM_PRODUCT(downloadCode),
    undefined,
    20000,
    AUTH_REDIRECT_URL(downloadCode),
  );
}

export function getBestellenSnippet(transactionId) {
  return get(BESTELLEN_SNIPPET(transactionId), "text/html", 20000);
}
